export const productData = [
    {
        id: "swas-ap",
        name: "swas-ap",
        image: "SWAS-AP.jpg",
        category: "tablets",
        description: "Aceclofenac 100 mg and Paracetamol 325 mg is a combined medication primarily used for pain relief and to reduce inflammation. It is commonly prescribed for various painful conditions affecting the joints and muscles, such as rheumatoid arthritis, osteoarthritis, and ankylosing spondylitis, as well as for general ailments like muscle pain, back pain, toothache, and fever. They work by blocking the action of chemical messengers (prostaglandins) in the body that cause pain, fever, and inflammation.",
        specs: [
            { label: "Composition", value: "Aceclofenac 100 mg + Paracetamol 325 mg" },
            { label: "Packing", value: "10 x 10 Tablets" },
        ]
    },
    {
        id: "swas-a-sp",
        name: "swas-a-sp",
        image: "SWAS-A-SP.jpg",
        category: "tablets",
        description: "A combination medication containing aceclofenac, paracetamol, and serratiopeptidase is used to relieve pain, inflammation, and swelling associated with various musculoskeletal and inflammatory conditions. This composition is a fixed-dose combination (FDC) therapy primarily used for its potent analgesic (pain-relieving), anti-inflammatory, and anti-edematous (anti-swelling) effects.",
        specs: [
            { label: "Composition", value: "Aceclofenac 100 mg. + Paracetamol 325 mg + Serratiopeptidase 10 mg" },
            { label: "Packing", value: "10 x 10 Tablets" },

        ]
    },
    {
        id: "swas-d-sp",
        name: "swas d-sp",
        image: "SWAS D-SP.jpg",
        category: "tablets",
        description: "A combination medication containing diclofenac potassium 50mg, paracetamol 325mg, and serratiopeptidase 10mg is used for pain relief, reducing inflammation, and lowering fever. This triple-action formula is commonly prescribed for various conditions, including musculoskeletal disorders like osteoarthritis and rheumatoid arthritis, as well as for managing different types of pain such as muscle ache, back pain, joint pain, menstrual cramps, and toothache.",
        specs: [
            { label: "Composition", value: "Diclofenac Potassium 50mg, Paracetamol 325mg and Serratiopeptidase 10mg" },
            { label: "Packing", value: "10 x 10 Tablets" },

        ]
    },
    {
        id: "swas-d-mr",
        name: "swas d-mr",
        image: "SWAS D-MR.jpg",
        category: "tablets",
        description: "The combination of diclofenac, paracetamol (also known as acetaminophen), and chlorzoxazone is a prescription medication used to treat musculoskeletal pain and muscle spasms. The individual components work together to provide pain relief, reduce inflammation, and relax tense muscles. This medication combines an anti-inflammatory painkiller, a general analgesic/fever reducer, and a muscle relaxant to provide comprehensive relief from conditions involving pain and muscle stiffness.",
        specs: [
            { label: "Composition", value: "Diclofenac 50mg + Paracetamol 325mg + Chlorzoxazone 250mg" },
            { label: "Packing", value: "10 x 10 Tablets" },

        ]
    },
    {
        id: "swasmol-650",
        name: "swasmol-650",
        image: "SWASMOL-650.jpg",
        category: "tablets",
        description: "Paracetamol 650 Tablet helps relieve pain and fever by blocking the release of certain chemical messengers responsible for fever and pain. It is used to treat headaches, migraine, toothaches, sore throats, period (menstrual) pains, arthritis, muscle aches, and the common cold.",
        specs: [
            { label: "Composition", value: "Paracetamol 650 mg" },
            { label: "Packing", value: "10 x 15 Tablets" },

        ]

    },
    {
        id: "rsp-montilev",
        name: "rsp-montilev",
        image: "RSP-MONTILEV.jpg",
        category: "tablets",
        description: "RSP-MONTILEV is a combination medication designed to provide relief from allergic symptoms and asthma. It contains Montelukast (10mg) and Levocetirizine (5mg), two active ingredients known for their effectiveness in managing respiratory and allergic conditions. This medication used in the treatment of allergic symptoms such as runny nose, stuffy nose, sneezing, itching, swelling, watery eyes, and congestion or stuffiness. It also reduces inflammation in the airways and makes breathing easier.",
        specs: [
            { label: "Composition", value: "Montelukast Sodium 10mg + Levocetirizine 5mg" },
            { label: "Packing", value: "10 x 10 Tablets" },

        ]
    },
    {
        id: "swasom",
        name: "swasom",
        image: "SWASOM.jpg",
        category: "tablets",
        description: "Omeprazole 20mg capsules serve to suppress the secretion of stomach acid, offering therapeutic benefits for a range of gastrointestinal disorders. These include acid-related diseases of the stomach and intestine, such as GERD, peptic ulcer disease, and Zollinger-Ellison syndrome, leading to symptom resolution and ulcer healing.",
        specs: [
            { label: "Composition", value: "Omeprazole Gastro-resistant Capsules IP 20 mg" },
            { label: "Packing", value: "10 x 15 Tablets" },

        ]
    },
    {
        id: "domeso-rsp",
        name: "domeso-rsp",
        image: "DOMESO-RSP.jpg",
        category: "tablets",
        description: "DOMESO-RSP Capsule is a prescription medicine used to treat gastroesophageal reflux disease (acid reflux). It helps relieve symptoms such as heartburn, stomach pain, or irritation. It also neutralizes the acid in the stomach and promotes easy gas passage to reduce stomach discomfort.",
        specs: [
            { label: "Composition", value: "Esomeprazole 40mg + Domperidone 30mg" },
            { label: "Packing", value: "10 x 10 Tablets" },

        ]
    },
    {
        id: "swasrab-dsr",
        name: "swasrab-dsr",
        image: "SWASRAB-DSR.jpg",
        category: "tablets",
        description: "A dual-action capsule for acid reflux, this medicine swiftly relieves symptoms such as heartburn and stomach pain. It works by both neutralizing stomach acid and promoting gas release, significantly reducing overall digestive discomfort.",
        specs: [
            { label: "Composition", value: "Rabeprazole 20mg + Domperidone 30mg" },
            { label: "Packing", value: "10 x 10 Tablets" },

        ]

    },
    {
        id: "roopan-40",
        name: "roopan-40",
        image: "ROOPAN-40.jpg",
        category: "tablets",
        description: "Pantoprazole 40 Tablet provides powerful relief from chronic acid problems. By lowering the amount of acid your stomach makes, it helps treat conditions like severe heartburn, acid reflux, and ulcers, allowing your stomach and intestinal lining to properly heal.",
        specs: [
            { label: "Composition", value: "Pantoprazole 40 mg" },
            { label: "Packing", value: "10 x 10 Tablets" },

        ]
    },
    {
        id: "roopan-dsr",
        name: "roopan-dsr",
        image: "ROOPAN-DSR.jpg",
        category: "tablets",
        description: "This combination medicine is a prescription drug primarily used to treat Gastroesophageal Reflux Disease (GERD), peptic ulcers, indigestion (dyspepsia), and gastritis. It is effective in relieving symptoms such as heartburn, acid reflux, upper abdominal pain, nausea, and vomiting.",
        specs: [
            { label: "Composition", value: "Pantoprazole 40mg + Domperidone 30mg" },
            { label: "Packing", value: "10 x 10 Tablets" },

        ]
    },
    {
        id: "telswa-40",
        name: "telswa - 40",
        image: "TELSWA-40.jpg",
        category: "tablets",
        description: "Telmisartan 40mg medication actively treats hypertension and heart failure. It works to reduce your blood pressure, which helps guard against strokes and heart attacks, and is specifically useful for protecting the kidneys of patients with diabetes",
        specs: [
            { label: "Composition", value: "Telmisartan 40mg" },
            { label: "Packing", value: "10 x 15 Tablets" },

        ]
    },
    {
        id: "telswa-h",
        name: "telswa-h",
        image: "TELSWA-H.jpg",
        category: "tablets",
        description: "This tablet is a combination therapy featuring Telmisartan (40mg) and Hydrochlorothiazide (12.5mg), designed to effectively manage high blood pressure (hypertension). It is typically prescribed when a single medication is insufficient to achieve optimal blood pressure control. By successfully lowering blood pressure, this dual treatment significantly reduces the risk of future cardiovascular events, including heart attack and stroke.",
        specs: [
            { label: "Composition", value: "Telmisartan 40mg + Hydrochlorothiazide 12.5mg" },
            { label: "Packing", value: "10 x 10 Tablets" },

        ]
    },
    {
        id: "swasglim-m1",
        name: "swasglim-m1",
        image: "SWASGLIM-M1.jpg",
        category: "tablets",
        description: "A combination anti-diabetic drug, this tablet contains Glimepiride (1mg) and Metformin (500mg) SR. It is prescribed for adults with Type 2 Diabetes to effectively manage and control their blood sugar levels.",
        specs: [
            { label: "Composition", value: "Metformin 500mg + Glimepiride 1mg" },
            { label: "Packing", value: "10 x 10 Tablets" },

        ]
    },
    {
        id: "swasglim-m2",
        name: "swasglim-m2",
        image: "SWASGLIM-M2.jpg",
        category: "tablets",
        description: "SWASGLIM-M2 Tablet belongs to a category of medicines known as anti-diabetic drugs. It is a combination of two medicines used to treat type 2 diabetes mellitus in adults. It helps control blood sugar levels in people with diabetes.",
        specs: [
            { label: "Composition", value: "Metformin 500mg + Glimepiride 2mg" },
            { label: "Packing", value: "10 x 10 Tablets" },

        ]
    },

    // sanitary pads
    {
        id: "cotton-pads-regular",
        name: "cotton soft touch pads regular",
        image: "sanitary-pads-R.jpg",
        category: "sanitary-pads",
        specs: [
            { label: "Size", value: "Regular - 240mm" },
            { label: "Packing", value: "7 Pads per Pack" },


        ]
    },
    {
        id: "cotton-pads-xl",
        name: "cotton soft touch pads xl",
        image: "sanitary-pads-XL.jpg",
        category: "sanitary-pads",
        specs: [
            { label: "Size", value: "XL - 280mm" },
            { label: "Packing", value: "6 Pads per Pack" },


        ]
    },
    {
        id: "kiah-comfort-organic-pads-xlplus",
        name: "kiah comfort organic pads xl+",
        image: "kiah-organic-pads-XL+.jpg",
        category: "sanitary-pads",
        description: "These Banana Fiber Pads (6 Pack) Experience ultra-soft, breathable protection designed for heavy flow and overnight wear. Crafted from non-toxic, biodegradable materials, our hypoallergenic pads ensure a rash-free, eco-friendly period.",
        specs: [
            { label: "Size", value: "XL+ - 280mm" },
            { label: "Packing", value: "6 Pads per Pack" },


        ]
    },
    {
        id: "kiah-comfort-organic-pads-xxl",
        name: "kiah comfort organic pads xxl",
        image: "kiah-organic-pads-XXL.jpg",
        category: "sanitary-pads",
        description: "These Banana Fiber Pads (6 Pack) Experience ultra-soft, breathable protection designed for heavy flow and overnight wear. Crafted from non-toxic, biodegradable materials, our hypoallergenic pads ensure a rash-free, eco-friendly period.",
        specs: [
            { label: "Size", value: "XXL - 320mm" },
            { label: "Packing", value: "6 Pads per Pack" },


        ]
    },

    // adult diapers
    {
        id: "adult-tape-style-diapers-unisex-m",
        name: "adult tape-style diapers unisex m ",
        image: "Tape M.jpg",
        category: "adult-diapers",
        specs: [
            { label: "Size", value: "M - 28-45inches(Waist)" },
           


        ]
    },
    {
        id: "adult-tape-style-diapers-unisex-l",
        name: "adult tape-style diapers unisex l",
        image: "Tape L.jpg",
        category: "adult-diapers",
        specs: [
            { label: "Size", value: "L - 38-54inches(Waist)" },
          


        ]
    },
    {
        id: "adult-tape-style-diapers-unisex-Xl",
        name: "adult tape-style diapers unisex Xl",
        image: "Tape XL.jpg",
        category: "adult-diapers",
        specs: [
            { label: "Size", value: "XL - 48-57inches(Waist)" },
           


        ]
    },
    {
        id: "adult-pant-style-diapers-unisex-m",
        name: "adult pant-style diapers unisex m",
        image: "pant M.jpg",
        category: "adult-diapers",
        specs: [
            { label: "Size", value: "M - 24-33inches(Waist)" },
           


        ]
    },
    {
        id: "adult-pant-style-diapers-unisex-l",
        name: "adult pant-style diapers unisex l",
        image: "pant L.jpg",
        category: "adult-diapers",
        specs: [
            { label: "Size", value: "L - 30-39inches(Waist)" },
           


        ]
    },
    {
        id: "adult-pant-style-diapers-unisex-xl",
        name: "adult pant-style diapers unisex xl",
        image: "pant XL.jpg",
        category: "adult-diapers",
        specs: [
            { label: "Size", value: "XL - 34-54inches(Waist)" },
        


        ]
    },

    // soaps
    {
        id: "glujic",
        name: "glujic skin whitening soap",
        image: "Glujic-soap.png",
        category: "soaps",
        description: "Glujic Soap is a specialized formula infused with L-Glutathione and Kojic Acid, two gold-standard ingredients for hyperpigmentation correction. This synergistic blend works to diminish the appearance of dark spots and uneven patches, promoting a clarified, luminous, and professionally brightened complexion."
    },
    {
        id: "ketoroop",
        name: "ketoroop anti fungal medicated soap",
        image: "ketoroob-soap.png",
        category: "soaps",
        description: "Ketoroob is a high-potency medicated soap featuring 2% Ketoconazole, a dermatologist-trusted antifungal agent. Engineered to eliminate fungal pathogens at the source, this targeted formula treats active infections and provides long-term prevention while maintaining the skin's natural integrity.",
        specs: [
            { label: "Active Ingredient", value: "2% Ketoconazole - A gold-standard antifungal clinically proven to eradicate infection-causing fungi and promote rapid skin recovery" },


        ]

    },

    // wet wipes
    {
        id: "bumkins",
        name: "bumkins premium baby wipes",
        image: "bumkins.jpg",
        category: "wet-wipes",
        description: "Pure Comfort for Delicate Skin. Crafted with ultra-soft, high-quality fabric, our wipes are infused with 99% purified water and skin-soothing botanical extracts. Free from harsh chemicals, fragrances, and alcohol, they provide a refreshing, irritation-free experience that keeps your little one’s skin soft and healthy.",
        specs: [
            { label: "Packing", value: "72 wipes" },

        ]
    },
    {
        id: "babify",
        name: "babify natural baby wipes - extra soft",
        image: "babify.jpeg",
        category: "wet-wipes",
        description: "Grounded in Nature, Made for your Baby. Pure, simple, and sustainably sourced. Babify Natural Baby Wipes are crafted from 100% plant-based fibers, offering an eco-friendly alternative to plastic-based wipes. Saturated with 99.9% pure water and organic extracts, they provide a refreshing clean that is as kind to the planet as it is to your baby’s skin.",
        specs: [
            { label: "Packing", value: "72 wipes" },

        ]
    },
    {
        id: "klara",
        name: "klara baby wipes",
        image: "klara.jpg",
        category: "wet-wipes",
        description: "Experience a new standard of softness with Klara Baby Wipes. Designed with a unique silk-soft texture, our wipes provide a gentle, cloud-like touch that never irritates. Perfectly moistened and dermatologically tested, Klara ensures that every diaper change is a moment of pure comfort and care.",
        specs: [
            { label: "Packing", value: "72 wipes" },

        ]
    }
];
